import {
  SALESPAYMENT_LOADING,
  GET_SALESPAYMENT,
  GET_SALESPAYMENT_SUCCESS,
  GET_SALESPAYMENT_FAIL,
  ADD_SALESPAYMENT_SUCCESS,
  ADD_SALESPAYMENT_FAIL,
  DELETE_SALESPAYMENT_SUCCESS,
  DELETE_SALESPAYMENT_FAIL,
  UPDATE_SALESPAYMENT_SUCCESS,
  UPDATE_SALESPAYMENT_FAIL,
  SALESPAYMENT_RESET
} from "./actionType";

const INIT_STATE = {
  salesPayments: [],
  error: {},
};

const SalesPayment = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALESPAYMENT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALESPAYMENT:
          return {
            ...state,
            salesPayments: action.payload.data,
            isSalesPaymentCreated: false,
            isSalesPaymentSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALESPAYMENT_FAIL:
      switch (action.payload.actionType) {
        case GET_SALESPAYMENT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesPaymentCreated: false,
            isSalesPaymentSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALESPAYMENT: {
      return {
        ...state,
        isSalesPaymentCreated: false,
        loading: true,
      };
    }

    case SALESPAYMENT_LOADING: {
      return {
        ...state,
        isSalesPaymentCreated: false,
        loading: true,
      };
    }

    case ADD_SALESPAYMENT_SUCCESS:
      return {
        ...state,
        isSalesPaymentCreated: true,
        loading: false,
        salesPayments: [action.payload.data, ...state.salesPayments],
      };

    case ADD_SALESPAYMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SALESPAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesPaymentCreated: true,
        salesPayments: state.salesPayments.filter(
          salesPayment => salesPayment.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALESPAYMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALESPAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesPaymentCreated: true,
        salesPayments: state.salesPayments.map(salesPayment =>
          salesPayment.id.toString() === action.payload.data.id.toString() ? { ...salesPayment, ...action.payload.data } : salesPayment
        ),
      };

    case UPDATE_SALESPAYMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SALESPAYMENT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SalesPayment;